var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Paper',{staticClass:"video-list",style:({
        'min-width': _vm.width ? _vm.width : '0',
        'max-width': _vm.width ? _vm.width : 'auto',
        width: _vm.width ? _vm.width : 'auto',
    }),attrs:{"header":_vm.$t('vfair.events.videos')}},[_c('div',{staticClass:"videos p-4"},_vm._l((_vm.value),function(video){return _c('VideoItem',{key:video.id,attrs:{"value":video}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }